/**
 * CommonLang.ts
 */
export class CommonLang {
    static getJurisdiction(id) {
        return CommonLang["PRELOADER_MESSAGE_" + id];
    }
}
CommonLang.FR_BONUS_START_TITLE = "GameLang.FR_BONUS_START_TITLE";
CommonLang.FR_BONUS_START_MESSAGE = "GameLang.FR_BONUS_START_MSG";
CommonLang.LOADER_GUIDE_BODY = "GameLang.LOADER_GUIDE_BODY_";
CommonLang.ROTATE_DEVICE = "GameLang.ROTATE_DEVICE";
CommonLang.DIALOG_TITLE = "GameLang.DIALOG_TITLE";
CommonLang.DIALOG_MESSAGE = "GameLang.DIALOG_MESSAGE";
CommonLang.YES_BUTTON = "GameLang.YES_BUTTON";
CommonLang.NO_BUTTON = "GameLang.NO_BUTTON";
CommonLang.OK_BUTTON = "GameLang.OK_BUTTON";
CommonLang.SAVE_BUTTON = "GameLang.SAVE_BUTTON";
CommonLang.CANCEL_BUTTON = "GameLang.CANCEL_BUTTON";
CommonLang.WAGER_HISTORY_BUTTON = "GameLang.WAGER_HISTORY_BUTTON";
CommonLang.EXIT_GAME_BUTTON = "GameLang.EXIT_GAME_BUTTON";
CommonLang.CONTINUE_BUTTON = "GameLang.CONTINUE_BUTTON";
CommonLang.BALANCE = "GameLang.BALANCE";
CommonLang.OPTIONS_SFX_SOUND = "GameLang.OPTIONS_SFX_SOUND";
CommonLang.OPTIONS_BACKGROUND_SOUND = "GameLang.OPTIONS_BACKGROUND_SOUND";
CommonLang.OPTIONS_HELP = "GameLang.OPTIONS_HELP";
CommonLang.OPTIONS_LOBBY = "GameLang.OPTIONS_LOBBY";
CommonLang.OPTIONS_DEPOSIT = "GameLang.OPTIONS_DEPOSIT";
CommonLang.OPTIONS_PAYS = "GameLang.OPTIONS_PAYS";
CommonLang.OPTIONS_RESPONSIBLE_GAMING = "GameLang.OPTIONS_RESPONSIBLE_GAMING";
CommonLang.OPTIONS_DGH = "GameLang.OPTIONS_DGH";
CommonLang.RECOVERY_TITLE = "GameLang.RECOVERY_TITLE";
CommonLang.RECOVERY_MESSAGE = "GameLang.RECOVERY_MESSAGE";
CommonLang.REALITY_CHECK_TITLE = "GameLang.REALITY_CHECK_TITLE";
CommonLang.REALITY_CHECK_OPTIONS_MESSAGE = "GameLang.REALITY_CHECK_OPTIONS_MESSAGE";
CommonLang.REALITY_CHECK_NO_OPTIONS_MESSAGE = "GameLang.REALITY_CHECK_NO_OPTIONS_MESSAGE";
CommonLang.REALITY_CHECK_WIN = "GameLang.REALITY_CHECK_WIN";
CommonLang.REALITY_CHECK_WAGERED = "GameLang.REALITY_CHECK_WAGERED";
CommonLang.SESSION_TIME_OUT_TITLE = "GameLang.SESSION_TIME_OUT_TITLE";
CommonLang.SESSION_TIME_OUT_MESSAGE = "GameLang.SESSION_TIME_OUT_MESSAGE";
CommonLang.CURRENCY_NOT_SUPPORTED_TITLE = "GameLang.CURRENCY_NOT_SUPPORTED_TITLE";
CommonLang.CURRENCY_NOT_SUPPORTED_MESSAGE = "GameLang.CURRENCY_NOT_SUPPORTED_MESSAGE";
CommonLang.INSUFFICIENT_FUNDS_TITLE = "GameLang.INSUFFICIENT_FUNDS_TITLE";
CommonLang.INSUFFICIENT_FUNDS_DEPOSIT_MESSAGE = "GameLang.INSUFFICIENT_FUNDS_DEPOSIT_MESSAGE";
CommonLang.INSUFFICIENT_FUNDS_NO_DEPOSIT_MESSAGE = "GameLang.INSUFFICIENT_FUNDS_NO_DEPOSIT_MESSAGE";
CommonLang.INSUFFICIENT_FUNDS_RESPONSIBLE_GAMING_MESSAGE = "GameLang.INSUFFICIENT_FUNDS_RESPONSIBLE_GAMING_MESSAGE";
CommonLang.ACCOUNT_LIMIT_EXCEEDED_TITLE = "GameLang.ACCOUNT_LIMIT_EXCEEDED_TITLE";
CommonLang.ACCOUNT_LIMIT_EXCEEDED_MESSAGE = "GameLang.ACCOUNT_LIMIT_EXCEEDED_MESSAGE";
CommonLang.ACCOUNT_LIMIT_EXCEEDED_GENERIC_TITLE = "GameLang.ACCOUNT_LIMIT_EXCEEDED_GENERIC_TITLE";
CommonLang.ACCOUNT_LIMIT_EXCEEDED_GENERIC_MESSAGE = "GameLang.ACCOUNT_LIMIT_EXCEEDED_GENERIC_MESSAGE";
CommonLang.RESPONSIBLE_GAMING_TURNOVER_LIMIT_TITLE = "GameLang.RESPONSIBLE_GAMING_TURNOVER_LIMIT_TITLE";
CommonLang.RESPONSIBLE_GAMING_TURNOVER_LIMIT_MESSAGE = "GameLang.RESPONSIBLE_GAMING_TURNOVER_LIMIT_MESSAGE";
CommonLang.FREE_GAME_AVAILABLE_TITLE = "GameLang.FREE_GAME_AVAILABLE_TITLE";
CommonLang.FREE_GAME_AVAILABLE_MESSAGE = "GameLang.FREE_GAME_AVAILABLE_MESSAGE";
CommonLang.FREE_GAME_COMPLETE_TITLE = "GameLang.FREE_GAME_COMPLETE_TITLE";
CommonLang.FREE_GAME_COMPLETE_WIN_MESSAGE = "GameLang.FREE_GAME_COMPLETE_WIN_MESSAGE";
CommonLang.FREE_GAME_COMPLETE_CONTINUE_MESSAGE = "GameLang.FREE_GAME_COMPLETE_CONTINUE_MESSAGE";
CommonLang.WAGER_BONUS_TITLE = "GameLang.WAGER_BONUS_TITLE";
CommonLang.WAGER_BONUS_MESSAGE = "GameLang.WAGER_BONUS_MESSAGE";
CommonLang.WAGER_CASH_TITLE = "GameLang.WAGER_CASH_TITLE";
CommonLang.WAGER_CASH_MESSAGE = "GameLang.WAGER_CASH_MESSAGE";
CommonLang.TERMS_AND_CONDITIONS = "GameLang.TERMS_AND_CONDITIONS";
CommonLang.PRELOADER_MESSAGE_UK = "GameLang.PRELOADER_MESSAGE_UK";
CommonLang.PRELOADER_MESSAGE_GIBRALTAR = "GameLang.PRELOADER_MESSAGE_GIBRALTAR";
CommonLang.RESPONSIBLE_GAMING_TITLE = "GameLang.RESPONSIBLE_GAMING_TITLE";
CommonLang.RESPONSIBLE_GAMING_MESSAGE_PREFIX = "GameLang.RESPONSIBLE_GAMING_MESSAGE_";
CommonLang.RESPONSIBLE_GAMING_TIME_LIMIT_TITLE = "GameLang.RESPONSIBLE_GAMING_TIME_LIMIT_TITLE";
CommonLang.RESPONSIBLE_GAMING_TIME_LIMIT_MESSAGE = "GameLang.RESPONSIBLE_GAMING_TIME_LIMIT_MESSAGE";
CommonLang.RESPONSIBLE_GAMING_SPIN_PRICE_THRESHOLD_TITLE = "GameLang.RESPONSIBLE_GAMING_SPIN_PRICE_THRESHOLD_TITLE";
CommonLang.RESPONSIBLE_GAMING_SPIN_PRICE_THRESHOLD_MESSAGE = "GameLang.RESPONSIBLE_GAMING_SPIN_PRICE_THRESHOLD_MESSAGE";
CommonLang.RESPONSIBLE_GAMING_ACTIVE_SUFFIX = "_ACTIVE";
CommonLang.RESPONSIBLE_GAMING_EXTRA_SPIN = "GameLang.RESPONSIBLE_GAMING_EXTRA_SPIN";
CommonLang.RESPONSIBLE_GAMING_SPIN_PRICE = "GameLang.RESPONSIBLE_GAMING_SPIN_PRICE";
CommonLang.RESPONSIBLE_GAMING_SINGLE_GAME_STAKE = "GameLang.RESPONSIBLE_GAMING_SINGLE_GAME_STAKE";
CommonLang.RESPONSIBLE_GAMING_MAXIMUM_LOSS = "GameLang.RESPONSIBLE_GAMING_MAXIMUM_LOSS";
CommonLang.INSTRUCTIONS_TOP_MESSAGE = "GameLang.INSTRUCTIONS_TOP_MESSAGE_";
CommonLang.INSTRUCTIONS_BOTTOM_MESSAGE = "GameLang.INSTRUCTIONS_BOTTOM_MESSAGE_";
CommonLang.RTP_INFO = "GameLang.RTP_INFO";
CommonLang.DEMO_PLAY = "GameLang.DEMO_PLAY";
CommonLang.STAKE_BUTTON = "GameLang.STAKE_BUTTON";
CommonLang.DONT_SHOW_BUTTON = "GameLang.DONT_SHOW_BUTTON";
CommonLang.ERROR_TITLE = "GameLang.ERROR_TITLE";
CommonLang.ERROR_MESSAGE = "GameLang.ERROR_MESSAGE";
CommonLang.SIGNPOSTING_GIBRALTAR = "GameLang.SIGNPOSTING_GIBRALTAR";
CommonLang.RESTRICTED_TERRITORY_TITLE = "GameLang.RESTRICTED_TERRITORY_TITLE";
CommonLang.RESTRICTED_TERRITORY_MESSAGE = "GameLang.RESTRICTED_TERRITORY_MESSAGE";
CommonLang.AUTO_COMPLETE = "GameLang.AUTO_COMPLETE";
CommonLang.AUTO_COMPLETE_PARAM = "GameLang.AUTO_COMPLETE_PARAM";
CommonLang.PARAM_AMOUNT = "{param.amount}";
CommonLang.PARAM_RTP = "{param.rtp}";
CommonLang.STAKE_LIMITS_TITLE = "GameLang.STAKE_LIMITS_TITLE";
CommonLang.GAME_OVER_CONFIRM_MESSAGE = "GameLang.GAME_OVER_CONFIRM_MESSAGE";
CommonLang.PURCHASE_STAKE_EXCEEDED_MESSAGE = "GameLang.PURCHASE_STAKE_EXCEEDED_MESSAGE";
CommonLang.TOTAL_STAKE_EXCEEDED_MESSAGE = "GameLang.TOTAL_STAKE_EXCEEDED_MESSAGE";
CommonLang.CLOSE_BUTTON = "GameLang.CLOSE_BUTTON";
CommonLang.ACCESSIBLE_COLOUR_BUTTON = "GameLang.ACCESSIBLE_COLOUR_BUTTON";
CommonLang.ACCESSIBLE_TOGGLE_CONFIRM = "GameLang.ACCESSIBLE_TOGGLE_CONFIRM";
//# sourceMappingURL=CommonLang.js.map